import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  margin-top: 2rem;
  margin-bottom: 3rem;
  width: 80%;
`;
